import React from "react";
import { Link } from "react-router-dom";
import styles from "./BreadCrumb.module.css";

function BreadCrumb({Route, RouteLabel, ProductName, CategoryName, CategoryLink }) {
  const displayRoute = RouteLabel || Route;
  return (
    <div className={styles.BreadCrumb}>
      <Link to={`/${Route}`} className={styles.a}>{displayRoute.toUpperCase()}</Link>
      {CategoryName && (
        <Link to={`/${Route}/${CategoryLink}`} className={styles.a}> {`>`} {CategoryName.toUpperCase()}</Link>
      )}
      {ProductName && <span className={styles.a}> {`>`} {ProductName.toUpperCase()}</span>}
    </div>
  );
}

export default BreadCrumb;
